import script from "./memberCard.vue?vue&type=script&setup=true&lang=js"
export * from "./memberCard.vue?vue&type=script&setup=true&lang=js"

import "./memberCard.vue?vue&type=style&index=0&id=01a4ea3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01a4ea3c"]])

export default __exports__